/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Change_Nickname_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to change their own nickname, a custom name for just this server." |
*
* @param {Leveling_Perm_Change_Nickname_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_change_nickname_hint = /** @type {((inputs?: Leveling_Perm_Change_Nickname_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Change_Nickname_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам менять свой никнейм — имя, которое видно только на этом сервере.")
	return /** @type {LocalizedString} */ ("Allows members to change their own nickname, a custom name for just this server.")
});